import React from "react";
import CustomModal from "../../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import Button from "../../../../Core/Components/CustomButton";
import { AlertTriangleIcon } from "../../../../Common/Svgs/AlertIcon";

const CannotDeleteLockerModal = ({
  visible,
  onCancel,
  title = "Cannot delete locker",
  description = "This locker contains an assigned battery. Remove the battery before deleting this locker.",
}) => {
  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <CustomRoundedImage
            size="w-12 h-12"
            image={<AlertTriangleIcon className="fill-none stroke-white" />}
            background="bg-alert-red"
          />

          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            {title}
          </p>

          <p className="mt-2 text-xs font-normal text-black font-aileron">
            {description}
          </p>
        </div>

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Close
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default CannotDeleteLockerModal;
